import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    border-radius: 10px;
    border: 2px dashed ${props => props.theme.colors.secondary};
    padding: 15px;

    &.highlight {
        background-color: #FFF;
    }

    input {
        &[type=file] {
            display: none;
        }
    }

    .fileUploadButton {
        background: ${props => props.theme.colors.secondary};
        color: ${props => props.theme.textColor.secondary};
        padding: 10px;
        border-radius: 8px;
        display: inline-block;
        margin-top: 10px;
        cursor: pointer;
    }
`;

export const FileList = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    margin-top: 10px;
    grid-gap: 10px;
`;

export const FileItem = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    background-color: #FFF;
    border-radius: 10px;
    border: 1px solid ${props => props.theme.colors.background};
`;

export const FileItemPreview = styled.div`
    width: 100px;
    height: 100px;
    border-radius: 10px 0 0 10px;
    background-color: #CDCDCD;
`;

export const FileItemInfo = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding-right: 10px;
    padding: 10px;
`;

export const FileItemDetails = styled.div`
    display: flex;
    flex: 1;
`;

export const FileItemProgress = styled.progress`
    appearance: none;
    display: flex;
    width: 100%;

    ::-webkit-progress-bar {
        background-color:${props=>props.theme.colors.background};
    }

    ::-webkit-progress-value {
        background-color:${props=>props.theme.colors.primary};    
    }
`;